import { render, staticRenderFns } from "./FaturaEdit.vue?vue&type=template&id=f9b1f2b6&scoped=true"
import script from "./FaturaEdit.vue?vue&type=script&lang=js"
export * from "./FaturaEdit.vue?vue&type=script&lang=js"
import style0 from "./FaturaEdit.vue?vue&type=style&index=0&id=f9b1f2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b1f2b6",
  null
  
)

export default component.exports